import React, { Component } from 'react';
import { getColor, getTextColor } from '../../common/ThemeService';
import './NewFeature.css';

class NewFeature extends Component {

    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        return (
            <div id="NewFeatureModal" className="modal fade" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog NewFeature_ModalDialog" role="document">
                    <div className="modal-content NewFeature_content">
                        <div className="newFeatureModalWrapper">
                            <img className="NewFeatureImage"  src={this.props.baseUrlImg + "/images/MyHands/newFeature.gif"} alt="newFeatureGIF"></img>
                            <div className="NewFeatureTitle">
                            {this.props.i18next.t("lable.newFeature")}!
                            </div>
                            <div className="NewFeatureDescription">
                            {this.props.i18next.t("lable.selectMultipleHandstoReplay")}!
                            </div>
                            <div className="NewFeatureGreatThanksBtn" data-e2e="greatThanks" data-dismiss="modal"
                                style={{
                                    backgroundColor: themeColor,
                                    color: themeTextColor,
                                    borderColor: themeColor
                                }}
                            >
                                {this.props.i18next.t("lable.greatThanks")}!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NewFeature


/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/NewFeature.js
 **/